export interface ReceiptLineValueInput {
  qty: number;
  unit_price?: number;
}

export function reconcileReceiptLineTotals(
  lines: ReceiptLineValueInput[],
  totalValue: number,
): number[] {
  const displayed = lines.map((line) => Math.round(
    Math.max(0, Number(line.qty || 0)) * Number(line.unit_price || 0),
  ));
  const target = Math.round(Number(totalValue || 0));
  const residual = target - displayed.reduce((sum, value) => sum + value, 0);
  if (residual === 0) return displayed;

  const lastPositiveIndex = lines.reduce(
    (lastIndex, line, index) => Number(line.qty || 0) > 0 ? index : lastIndex,
    -1,
  );
  if (lastPositiveIndex < 0) return displayed;

  return displayed.map((value, index) => index === lastPositiveIndex ? value + residual : value);
}
